import { Home, Briefcase, BookOpen, Flower2, Gift } from "lucide-react";
import { Reveal, ChapterHead } from "./shared";

const SPACES = [
  {
    icon: Home,
    title: "Home Décor",
    text: "A distinctive decorative accent for living rooms, bedrooms, shelves and personal spaces.",
    testid: "space-card-home",
  },
  {
    icon: Briefcase,
    title: "Workspaces",
    text: "A colourful natural element for desks, offices and creative environments.",
    testid: "space-card-workspace",
  },
  {
    icon: BookOpen,
    title: "Study Areas",
    text: "A calm, colourful companion for reading corners and study desks.",
    testid: "space-card-study",
  },
  {
    icon: Flower2,
    title: "Meditation & Reflection",
    text: "A symbolic object that can complement personal meditation, yoga or reflection practices.",
    testid: "space-card-meditation",
  },
  {
    icon: Gift,
    title: "Gifting",
    text: "A thoughtful decorative gift for people interested in gemstones, spirituality, mindfulness or meaningful décor.",
    testid: "space-card-gifting",
  },
];

export default function EverydaySpaces() {
  return (
    <section className="py-20 lg:py-32 bg-[#1B1915] text-[#FDFBF7]" data-testid="everyday-spaces-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-16">
          <ChapterHead
            number="04"
            label="Everyday Lifestyle"
            title="Bring It Into Your Space"
            dark
            testid="spaces"
          />
          <Reveal delay={0.15}>
            <p className="mt-6 text-base sm:text-lg text-[#FDFBF7]/65 leading-relaxed" data-testid="spaces-intro">
              Designed as decorative and reflective décor, the tree finds its place
              naturally across the spaces you live, work and unwind in.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SPACES.map((s, i) => (
            <Reveal key={s.title} delay={(i % 2) * 0.12}>
              <div
                className="group h-full p-8 lg:p-12 border border-[#FDFBF7]/12 rounded-sm bg-[#2C2822]/25 hover:bg-[#2C2822]/45 hover:-translate-y-1.5 transition-[transform,background-color,border-color] duration-500 hover:border-[#FDFBF7]/25"
                data-testid={s.testid}
              >
                <s.icon className="w-6 h-6 text-[#C6A15B] mb-8" strokeWidth={1.5} />
                <h3 className="font-serif-display text-2xl tracking-tight mb-3">{s.title}</h3>
                <p className="text-sm sm:text-base text-[#FDFBF7]/60 leading-relaxed">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
